import React from "react";
import { ProducerAccountPreviewBalanceTemplate } from "themes/common/components/producer";

function ProducerAccountPreviewBalance(props) {
    return <ProducerAccountPreviewBalanceTemplate {...props} />;
}

export default ProducerAccountPreviewBalance;
